import React, { useState } from 'react';
import { Plus, Search, Edit, Trash2, Package } from 'lucide-react';

const SystemsManagement = () => {
    const [systems] = useState([
        { id: 1, name: 'Liste Asistanı', status: 'Canlı', type: 'SaaS', price: '1000 ₺' },
        { id: 2, name: 'B2B Stok Yönetimi', status: 'Geliştirme', type: 'B2B', price: 'N/A' },
        { id: 3, name: 'WebAnt', status: 'Test', type: 'SaaS', price: 'N/A' }
    ]);

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Sistem Yönetimi</h1>
                    <p className="text-gray-600">cezec.dev ana sayfasında görünen sistemleri yönetin.</p>
                </div>
                <button className="bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2 hover:bg-blue-700 transition">
                    <Plus size={18} /> Yeni Sistem Ekle
                </button>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                <div className="p-4 border-b border-gray-100 flex items-center gap-4">
                    <div className="relative flex-1">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                        <input
                            type="text"
                            placeholder="Sistem ara..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                </div>

                <table className="w-full text-left">
                    <thead className="bg-gray-50 text-gray-600 text-sm uppercase">
                        <tr>
                            <th className="px-6 py-3">Sistem Adı</th>
                            <th className="px-6 py-3">Tür</th>
                            <th className="px-6 py-3">Durum</th>
                            <th className="px-6 py-3">Fiyat</th>
                            <th className="px-6 py-3 text-right">Eylemler</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {systems.map((system) => (
                            <tr key={system.id} className="hover:bg-gray-50 transition">
                                <td className="px-6 py-4 font-medium text-gray-900 flex items-center gap-3">
                                    <div className="w-8 h-8 rounded bg-blue-100 text-blue-600 flex items-center justify-center">
                                        <Package size={16} />
                                    </div>
                                    {system.name}
                                </td>
                                <td className="px-6 py-4 text-gray-600">{system.type}</td>
                                <td className="px-6 py-4">
                                    <span className={`px-2 py-1 rounded-full text-xs font-semibold ${system.status === 'Canlı' ? 'bg-green-100 text-green-700' :
                                            system.status === 'Test' ? 'bg-blue-100 text-blue-700' : 'bg-yellow-100 text-yellow-700'
                                        }`}>
                                        {system.status}
                                    </span>
                                </td>
                                <td className="px-6 py-4 text-gray-600">{system.price}</td>
                                <td className="px-6 py-4 text-right">
                                    <div className="flex justify-end gap-2">
                                        <button className="p-2 text-gray-400 hover:text-blue-600 transition"><Edit size={16} /></button>
                                        <button className="p-2 text-gray-400 hover:text-red-600 transition"><Trash2 size={16} /></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SystemsManagement;
